$(function () {
	APP.init();
	lozadInit();
	fancyboxInit();
	countUpInit();
	masonryInit();
	presaleTab();

	accordionCollapse();

	coreItemToggle();
	overview4ItemHover();
	changeLabelFile();
	homeOverview();
	loadMoreItem();
	industrialTabSection();

	toggleFaqsAskModule();
});

$(window).on("scroll", function () {
	APP.fixed();
});

// variable
var header = $("header"),
	body = $("body"),
	backdrop = $(".backdrop"),
	toggleBackdrop = $(".toggle-backdrop"),
	backToTop = $(".back-to-top"),
	buttonMenu = $("#buttonMenu"),
	mobileWrap = $(".mobile-wrap"),
	buttonSearch = $("header .button-search"),
	searchWrap = $(".search-wrap"),
	heightHeader = $("header").height(),
	heightWindow = $(window).height(),
	widthWindow = $(window).width(),
	outerHeightWindow = $(window).outerHeight();

// toggleText
$.fn.extend({
	toggleText: function (a, b) {
		return this.text(this.text() == b ? a : b);
	},
});

var APP = {
	fixed: () => {
		// header
		$(window).scrollTop() > heightHeader
			? header.addClass("active")
			: header.removeClass("active");
		$(window).scrollTop() > outerHeightWindow - heightHeader
			? backToTop.addClass("active")
			: backToTop.removeClass("active");
	},
	backdrop: () => {
		backdrop.on("click", function () {
			$(this).fadeOut();
		});
	},
	backToTop: () => {
		backToTop.on("click", function () {
			$("html, body").animate({ scrollTop: 0 }, 500);
		});
	},
	mapping: () => {
		let mainMenu = $("header .navbar-nav").mapping({
			mobileWrapper: "header .mobile-wrap",
			mobileMethod: "prependTo",
			desktopWrapper: "header .button-consortium",
			desktopMethod: "insertBefore",
			breakpoint: 1279.98,
		});
		let social = $("header .navbar-social").mapping({
			mobileWrapper: "header .mobile-wrap",
			mobileMethod: "appendTo",
			desktopWrapper: "header .header-left",
			desktopMethod: "prependTo",
			breakpoint: 1279.98,
		});
	},
	toggleDropdown: () => {
		var dropdownToggle = $(".dropdown-toggle"),
			dropdownMenu = $(".dropdown-menu");
	},
	toggleMenuMobile: () => {
		$(buttonMenu).on("click", function () {
			mobileWrap.slideDown().toggleClass("active");
			$(".backdrop-mobile").fadeIn();
		});

		$(mobileWrap)
			.find(".close-mobile")
			.on("click", function () {
				mobileWrap.fadeOut().removeClass("active");
				$(".backdrop-mobile").fadeOut();
			});

		$(document).on("click", function (e) {
			if (
				!$(e.target).closest(mobileWrap).length &&
				!$(e.target).closest(buttonMenu).length
			) {
				mobileWrap.fadeOut().removeClass("active");
				$(".backdrop-mobile").fadeOut();
			}
		});
	},
	toggleMobileChildren: () => {
		$(".main-menu li.menu-item-has-children").on("click", function () {
			$(this).toggleClass("active").find("> .sub-menu").slideToggle();
			$(this)
				.siblings()
				.removeClass("active")
				.find("> .sub-menu")
				.slideUp();
		});
	},
	toggleSearch: () => {
		buttonSearch.on("click", function () {
			searchWrap.fadeToggle();
			searchWrap.find("input").trigger("focus");
			$(".backdrop-search").fadeToggle("fast");
		});

		$(document).on("click", function (e) {
			if (
				!$(e.target).closest(searchWrap).length &&
				!$(e.target).closest(buttonSearch).length
			) {
				searchWrap.fadeOut("fast");
				$(".backdrop-search").fadeOut("fast");
			}
		});
	},
	init: () => {
		APP.backdrop();
		APP.backToTop();
		APP.mapping();
		APP.toggleMenuMobile();
		APP.toggleMobileChildren();
		APP.toggleSearch();
	},
};

var defaultSettingSwiper = {
	preventInteractionOnTransition: true,
	observer: true,
	observeParents: true,
	lazy: {
		loadPrevNext: true,
	},
};

const homeBannerSwiper = new Swiper(".banner-slider .swiper", {
	loop: true,
	autoplay: {
		delay: 5000,
		disableOnInteraction: false,
		pauseOnMouseEnter: true,
	},
	effect: "fade",
	speed: 1000,
	...defaultSettingSwiper,
	navigation: {
		nextEl: ".banner-slider .button-next",
		prevEl: ".banner-slider .button-prev",
	},
	pagination: {
		el: ".banner-slider .swiper-pagination",
		clickable: true,
	},
});

$(".one-slider").each(function (index) {
	var loopDefault = {
		loop: true,
	};
	var autoplayDefault = {
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
	};
	var centeredSlidesDefault = {};
	if ($(this).hasClass("no-loop")) {
		loopDefault = {
			loop: false,
		};
	}
	if ($(this).hasClass("no-autoplay")) {
		autoplayDefault = {
			autoplay: false,
		};
	}
	if ($(this).hasClass("centered-slides")) {
		centeredSlidesDefault = {
			centeredSlides: true,
			centeredSlidesBounds: true,
		};
	}
	$(this).find(".swiper").addClass(`swiper-one-${index}`);
	$(this).find(".swiper-pagination").addClass(`pagination-one-${index}`);
	$(this).find(".button-prev").addClass(`prev-one-${index}`);
	$(this).find(".button-next").addClass(`next-one-${index}`);
	const oneSlider = new Swiper(`.swiper-one-${index}`, {
		...defaultSettingSwiper,
		...loopDefault,
		...autoplayDefault,
		...centeredSlidesDefault,
		speed: 1000,
		spaceBetween: 16,
		slidesPerView: 1,
		slideToClickedSlide: true,
		loopAdditionalSlides: 1,
		navigation: {
			prevEl: `.one-slider .prev-one-${index}`,
			nextEl: `.one-slider .next-one-${index}`,
		},
		pagination: {
			el: `.one-slider .pagination-one-${index}`,
			clickable: true,
			dynamicBullets: true,
		},
		breakpoints: {
			1200: {
				spaceBetween: 32,
			},
		},
	});
});

$(".two-slider").each(function (index) {
	var loopDefault = {
		loop: true,
	};
	var autoplayDefault = {
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
	};
	var centeredSlidesDefault = {};
	if ($(this).hasClass("no-loop")) {
		loopDefault = {
			loop: false,
		};
	}
	if ($(this).hasClass("no-autoplay")) {
		autoplayDefault = {
			autoplay: false,
		};
	}
	if ($(this).hasClass("centered-slides")) {
		centeredSlidesDefault = {
			centeredSlides: true,
			centeredSlidesBounds: true,
		};
	}
	$(this).find(".swiper").addClass(`swiper-two-${index}`);
	$(this).find(".swiper-pagination").addClass(`pagination-two-${index}`);
	$(this).find(".button-prev").addClass(`prev-two-${index}`);
	$(this).find(".button-next").addClass(`next-two-${index}`);
	const twoSlider = new Swiper(`.swiper-two-${index}`, {
		...defaultSettingSwiper,
		...loopDefault,
		...autoplayDefault,
		speed: 1000,
		spaceBetween: 16,
		slidesPerView: 1,
		navigation: {
			prevEl: `.two-slider .prev-two-${index}`,
			nextEl: `.two-slider .next-two-${index}`,
		},
		pagination: {
			el: `.two-slider .pagination-two-${index}`,
			clickable: true,
			dynamicBullets: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 32,
			},
			1200: {
				slidesPerView: 2,
				spaceBetween: 32,
			},
		},
	});
});

$(".three-slider").each(function (index) {
	var loopDefault = {
		loop: true,
	};
	var autoplayDefault = {
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
	};
	var centeredSlidesDefault = {};
	if ($(this).hasClass("no-loop")) {
		loopDefault = {
			loop: false,
		};
	}
	if ($(this).hasClass("no-autoplay")) {
		autoplayDefault = {
			autoplay: false,
		};
	}
	if ($(this).hasClass("centered-slides")) {
		centeredSlidesDefault = {
			centeredSlides: true,
			centeredSlidesBounds: true,
		};
	}
	$(this).find(".swiper").addClass(`swiper-three-${index}`);
	$(this).find(".swiper-pagination").addClass(`pagination-three-${index}`);
	$(this).find(".button-prev").addClass(`prev-three-${index}`);
	$(this).find(".button-next").addClass(`next-three-${index}`);
	const threeSlider = new Swiper(`.swiper-three-${index}`, {
		...defaultSettingSwiper,
		...loopDefault,
		...autoplayDefault,
		speed: 1000,
		spaceBetween: 16,
		slidesPerView: 1,
		navigation: {
			prevEl: `.three-slider .prev-three-${index}`,
			nextEl: `.three-slider .next-three-${index}`,
		},
		pagination: {
			el: `.three-slider .pagination-three-${index}`,
			clickable: true,
			dynamicBullets: true,
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
				spaceBetween: 16,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: 32,
			},
		},
	});
});

$(".four-slider").each(function (index) {
	var loopDefault = {
		loop: true,
	};
	var autoplayDefault = {
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
	};
	var centeredSlidesDefault = {};
	if ($(this).hasClass("no-loop")) {
		loopDefault = {
			loop: false,
		};
	}
	if ($(this).hasClass("no-autoplay")) {
		autoplayDefault = {
			autoplay: false,
		};
	}
	if ($(this).hasClass("centered-slides")) {
		centeredSlidesDefault = {
			centeredSlides: true,
			centeredSlidesBounds: true,
		};
	}
	$(this).find(".swiper").addClass(`swiper-four-${index}`);
	$(this).find(".swiper-pagination").addClass(`pagination-four-${index}`);
	$(this).find(".swiper-scrollbar").addClass(`scrollbar-four-${index}`);
	$(this).find(".button-prev").addClass(`prev-four-${index}`);
	$(this).find(".button-next").addClass(`next-four-${index}`);
	const fourSlider = new Swiper(`.swiper-four-${index}`, {
		...defaultSettingSwiper,
		...loopDefault,
		...autoplayDefault,
		speed: 1000,
		spaceBetween: 16,
		slidesPerView: 1,
		navigation: {
			prevEl: `.four-slider .prev-four-${index}`,
			nextEl: `.four-slider .next-four-${index}`,
		},
		pagination: {
			el: `.four-slider .pagination-four-${index}`,
			clickable: true,
			dynamicBullets: true,
		},
		scrollbar: {
			el: `.four-slider .scrollbar-four-${index}`,
			hide: false,
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
				spaceBetween: 16,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 32,
			},
		},
	});
});

$(".five-slider").each(function (index) {
	var loopDefault = {
		loop: true,
	};
	var autoplayDefault = {
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
	};
	var centeredSlidesDefault = {};
	if ($(this).hasClass("no-loop")) {
		loopDefault = {
			loop: false,
		};
	}
	if ($(this).hasClass("no-autoplay")) {
		autoplayDefault = {
			autoplay: false,
		};
	}
	if ($(this).hasClass("centered-slides")) {
		centeredSlidesDefault = {
			centeredSlides: true,
			centeredSlidesBounds: true,
		};
	}
	$(this).find(".swiper").addClass(`swiper-five-${index}`);
	$(this).find(".swiper-pagination").addClass(`pagination-five-${index}`);
	$(this).find(".button-prev").addClass(`prev-five-${index}`);
	$(this).find(".button-next").addClass(`next-five-${index}`);
	const fiveSlider = new Swiper(`.swiper-five-${index}`, {
		...defaultSettingSwiper,
		...loopDefault,
		...autoplayDefault,
		speed: 1000,
		spaceBetween: 16,
		slidesPerView: 1,
		navigation: {
			prevEl: `.five-slider .prev-five-${index}`,
			nextEl: `.five-slider .next-five-${index}`,
		},
		pagination: {
			el: `.five-slider .pagination-five-${index}`,
			clickable: true,
			dynamicBullets: true,
		},
		breakpoints: {
			576: {
				slidesPerView: 2,
				spaceBetween: 16,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 32,
			},
			1440: {
				slidesPerView: 5,
				spaceBetween: 32,
			},
		},
	});
});

$(".six-slider").each(function (index) {
	var loopDefault = {
		loop: true,
	};
	var autoplayDefault = {
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
	};
	var centeredSlidesDefault = {};
	if ($(this).hasClass("no-loop")) {
		loopDefault = {
			loop: false,
		};
	}
	if ($(this).hasClass("no-autoplay")) {
		autoplayDefault = {
			autoplay: false,
		};
	}
	if ($(this).hasClass("centered-slides")) {
		centeredSlidesDefault = {
			centeredSlides: true,
			centeredSlidesBounds: true,
		};
	}
	$(this).find(".swiper").addClass(`swiper-six-${index}`);
	$(this).find(".swiper-pagination").addClass(`pagination-six-${index}`);
	$(this).find(".button-prev").addClass(`prev-six-${index}`);
	$(this).find(".button-next").addClass(`next-six-${index}`);
	const sixSlider = new Swiper(`.swiper-six-${index}`, {
		...defaultSettingSwiper,
		...loopDefault,
		...autoplayDefault,
		speed: 1000,
		spaceBetween: 16,
		slidesPerView: 2,
		navigation: {
			prevEl: `.six-slider .prev-six-${index}`,
			nextEl: `.six-slider .next-six-${index}`,
		},
		pagination: {
			el: `.six-slider .pagination-six-${index}`,
			clickable: true,
			dynamicBullets: true,
		},
		breakpoints: {
			320: {
				slidesPerView: 2,
				spaceBetween: 16,
			},
			576: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			768: {
				slidesPerView: 4,
				spaceBetween: 16,
			},
			1024: {
				slidesPerView: 5,
				spaceBetween: 16,
			},
			1200: {
				slidesPerView: 6,
				spaceBetween: 32,
			},
		},
	});
});

$(".auto-slider").each(function (index) {
	var loopDefault = {
		loop: true,
	};
	var autoplayDefault = {
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
	};
	var centeredSlidesDefault = {};
	var freeModeDefault = {};
	if ($(this).hasClass("no-loop")) {
		loopDefault = {
			loop: false,
		};
	}
	if ($(this).hasClass("no-autoplay")) {
		autoplayDefault = {
			autoplay: false,
		};
	}
	if ($(this).hasClass("one-autoplay")) {
		autoplayDefault = {
			autoplay: {
				delay: 1,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
			},
		};
	}
	if ($(this).hasClass("centered-slides")) {
		centeredSlidesDefault = {
			centeredSlides: true,
			centeredSlidesBounds: true,
		};
	}
	if ($(this).hasClass("centered-slides")) {
		centeredSlidesDefault = {
			centeredSlides: true,
			centeredSlidesBounds: true,
		};
	}
	if ($(this).hasClass("is-free-mode")) {
		freeModeDefault = {
			freeMode: true,
		};
	}
	$(this).find(".swiper").addClass(`swiper-auto-${index}`);
	$(this).find(".swiper-pagination").addClass(`pagination-auto-${index}`);
	$(this).find(".button-prev").addClass(`prev-auto-${index}`);
	$(this).find(".button-next").addClass(`next-auto-${index}`);
	const autoSlider = new Swiper(`.swiper-auto-${index}`, {
		...defaultSettingSwiper,
		...loopDefault,
		...autoplayDefault,
		...freeModeDefault,
		speed: 3000,
		spaceBetween: 16,
		slidesPerView: "auto",
		navigation: {
			prevEl: `.auto-slider .prev-auto-${index}`,
			nextEl: `.auto-slider .next-auto-${index}`,
		},
		pagination: {
			el: `.auto-slider .pagination-auto-${index}`,
			clickable: true,
		},
		breakpoints: {
			1280: {
				spaceBetween: 32,
			},
		},
	});
});

function lozadInit() {
	// Initialize library to lazy load images
	const observer = lozad(".lozad", {
		threshold: 0.1,
		enableAutoReload: true,
	});
	// data-background-image="image.png"
	const backgroundObserver = lozad(".lozad-bg", {
		threshold: 0.1,
	});
	observer.observe();
	backgroundObserver.observe();
}

function fancyboxInit() {
	Fancybox.bind("[data-fancybox]", {
		showLoading: true,
		preload: true,
		infinite: false,
		// parentEl: document.forms[0], // Element containing main structure
		mainClass: "fancybox-wrapper", // Custom class name or multiple space-separated class names for the container
	});

	Fancybox.bind("a.popup-link", {
		showLoading: true,
		type: "iframe",
		preload: true,
	});

	Fancybox.bind('[data-fancybox="single"]', {
		groupAttr: false,
	});

	$(".btn-close-fancybox").on("click", function () {
		Fancybox.close();
	});

	$(".news-detail-section .full-content img").each(function () {
		$(this).wrap(
			`<a href="${$(this).attr(
				"src"
			)}" data-fancybox="news-detail" data-caption="${$(this).attr(
				"alt"
			)}"></a>`
		);
	});
}

function countUpInit() {
	$(".count-up").each(function (index) {
		$(this).attr("id", `countUp-${index}`);
		const endVal = $(this).data("count");

		const options = {
			separator: ",",
			enableScrollSpy: true,
			scrollSpyDelay: 1000,
			scrollSpyOnce: true,
		};

		const countUp = new CountUp(`countUp-${index}`, endVal, options);

		if (!countUp.error) {
			countUp.start();
		} else {
			console.error(countUp.error);
		}

		countUp.handleScroll();
	});
}

function masonryInit() {
	$(".event-grid").masonry({
		itemSelector: ".grid-item",
		gutter: 32,
		// horizontalOrder: true,
	});
}

function presaleTab() {
	$(".property-all-section .tabslet-tabs li").on("click", function () {
		const dataTab = $(this).find("a").attr("href");
		$(".presale-wrap .presale-tab").fadeOut("fast");
		$(`.presale-wrap .presale-tab[data-tab="${dataTab}"]`).fadeIn("fast");
	});

	$(".presale-wrap .presale-tab:first-child").show();
}

function accordionCollapse() {
	$(".accordion-title").on("click", function () {
		$(this).parent().toggleClass("active").siblings().removeClass("active");
		$(this)
			.next()
			.slideToggle()
			.parents(".accordion-item")
			.siblings()
			.find(".accordion-content")
			.slideUp();
	});
}

function coreItemToggle() {
	$(".core-item .toggle-show").on("click", function () {
		$(this)
			.toggleClass("active")
			.closest(".core-item")
			.find(".desc")
			.slideToggle();
	});
}

function overview4ItemHover() {
	if (widthWindow > 1200) {
		$(".overview-4-item")
			.on("mouseenter", function () {
				$(this).find(".desc").slideDown("fast");
			})
			.on("mouseleave", function () {
				$(this).find(".desc").slideUp("fast");
			});
	}
}

function changeLabelFile() {
	$("#file-attach").on("change", function () {
		var fileName = $(this).val().split("\\").pop();
		$(".form-attachment > label").html(`<strong>${fileName}</strong>`);
	});
}

function homeOverview() {
	$(".home-overview-item")
		.on("mouseenter", function () {
			let imgSrc = $(this).data("background-image");
			$(".overview-cover-img")
				.addClass("active")
				.find("img")
				.attr("src", imgSrc);
		})
		.on("mouseleave", function () {
			$(".overview-cover-img").removeClass("active");
		});
}

function loadMoreItem() {
	$(".load-more-wrap").each(function () {
		let $this = $(this);
		let loadMore = $this.data("load-more");
		let loadMoreItem = $this.find(".load-more-item");
		let loadMoreButton = $this.find(".load-more-button");
		$(loadMoreItem).slice(0, loadMore).show();

		$(loadMoreButton).on("click", function (e) {
			e.preventDefault();
			let loadMoreItemHidden = $this.find(".load-more-item:hidden");
			$(loadMoreItemHidden).slice(0, loadMore).slideDown();
			let loadMoreItemHiddenLength = $this.find(
				".load-more-item:hidden"
			).length;
			if ($(loadMoreItemHiddenLength).length == 0) {
				$(loadMoreButton).fadeOut("slow");
			}
		});
	});
}

function industrialTabSection() {
	$(".tabslet-tabs li").on("click", function () {
		let tabID = $(this).find("a").attr("href");
		$(`.industrial-2-section`).fadeOut();
		$(`.industrial-2-section${tabID}-section`).fadeIn();
	});
}

function toggleFaqsAskModule() {
	$(".module-toggle").each(function () {
		const $this = $(this);
		let willOpenAll = $this.attr("data-open-all") || "false";
		let openFirstItem = $this.attr("data-open-first-item") || "false";
		let openAtleastOne = $this.attr("data-open-atleast-one") || "false";
		let showAll = $this.attr("data-show-all") || "false";
		let split = $this.attr("data-split") || 1;
		if (openFirstItem === "" || openFirstItem === "true") {
			$this
				.find(".item")
				.first()
				.addClass("active")
				.find(".bottom")
				.slideDown();
			$this.find(".item-trigger").first().addClass("active");
		}

		if (showAll === "true") {
			$this.find(".item").addClass("active").find(".bottom").show();
			$this.find(".item-trigger").addClass("active");
		}

		if (split > 1) {
			$this.addClass(`module-split-${split}`);
			let $items = $this.find(".item");
			let countItems = $items.length;
			let countItemsPerColumn = Math.ceil(countItems / split);
			for (let i = 0; i < split; i++) {
				const $column = $(
					`<div class="split-column split-column-${i}"></div>`
				);
				$this.append($column);
			}
			$items.each(function (index, item) {
				const cloneItem = $(item).clone();
				item.remove();
				cloneItem.addClass(`split-item-${index}`);
				cloneItem.attr("data-index", index);
				// * Push item to columns by item mod number of columns
				// $this.find(`.split-column-${index % split}`).append(cloneItem);
				// let columnIndex = index % split;
				// * Push item to columns by item order
				let columnIndex = Math.floor(index / (countItems / split));
				$this.find(`.split-column-${columnIndex}`).append(cloneItem);
			});
		}
		var item = $(this).find(".item .top");
		var itemTrigger = $(this).find(".item-trigger");
		item.on("click", function () {
			if (split > 1) {
				handleClickMultiColumn($(this).parent());
			} else {
				handleClickSingleColumn($(this).parent());
			}
		});
		itemTrigger.on("click", function () {
			if (split > 1) {
				handleClickMultiColumn($(this));
			} else {
				handleClickSingleColumn($(this));
			}
		});
		function handleClickSingleColumn(currentItem) {
			const index = currentItem.index();
			// console.log("🟩 ~ handleClickItem ~ index:", index);

			if (willOpenAll === "" || willOpenAll === "true") {
				currentItem.toggleClass("active");
				currentItem.find(".bottom").slideToggle();

				return;
			}
			$this
				.find(".item")
				.not(".item:eq(" + index + ")")
				.find(".bottom")
				.slideUp();
			$this
				.find(".item")
				.not(".item:eq(" + index + ")")
				.removeClass("active");
			$this
				.find(".item-trigger")
				.not(".item-trigger:eq(" + index + ")")
				.removeClass("active");

			if (currentItem.hasClass("active")) {
				if (openAtleastOne === "false") {
					$this.find(".item").removeClass("active");
					$this.find(".item").eq(index).find(".bottom").slideUp();
					$this.find(".item-trigger").removeClass("active");
				}
			} else {
				$this.find(".item").eq(index).addClass("active");
				$this.find(".item").eq(index).find(".bottom").slideDown();
				$this.find(".item-trigger").eq(index).addClass("active");
			}
		}

		function handleClickMultiColumn(currentItem) {
			const index = currentItem.attr("data-index");
			const parentColumnIndex = currentItem
				.closest(".split-column")
				.index();
			const isActive = currentItem.hasClass("active");
			let otherItems;
			// * Select all other items in all columns
			if (ww > 1024) {
				otherItems = $this
					.find(`.split-column-${parentColumnIndex}`)
					.find(`.item:not(.split-item-${index})`);
			} else {
				otherItems = $this.find(`.item:not(.split-item-${index})`);
			}

			// * Select all other items in the current column

			otherItems.find(".bottom").slideUp();
			otherItems.removeClass("active");

			if (isActive) {
				if (openAtleastOne === "false") {
					currentItem.find(".bottom").slideUp();
					currentItem.removeClass("active");
				}
			} else {
				currentItem.find(".bottom").slideDown();
				currentItem.addClass("active");
			}
		}
	});
}
